import React, { useState, useEffect, useCallback } from 'react';
import * as echarts from 'echarts';
import CustomToolTip from '../../CustomToolTip';

export interface TelemetryGlobalZoomButtonProps {
  timeframe?: number;
  viewport?: { spanMs: number; offsetMs: number };
  isZoomed?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const TelemetryGlobalZoomButton: React.FC<TelemetryGlobalZoomButtonProps> = ({
  className = '',
  style,
}) => {
  const [isZoomActive, setIsZoomActive] = useState(false);

  useEffect(() => {
    const handleZoomDeactivate = () => {
      setIsZoomActive(false);
    };
    window.addEventListener('telemetry:zoom-deactivate', handleZoomDeactivate);
    return () => {
      window.removeEventListener('telemetry:zoom-deactivate', handleZoomDeactivate);
    };
  }, []);

  const handleToggleGlobalZoom = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    const nextState = !isZoomActive;
    setIsZoomActive(nextState);

    const chartElements = document.querySelectorAll('.telemetry-chart-canvas-wrap');
    chartElements.forEach((el) => {
      const ec = echarts.getInstanceByDom(el as HTMLElement);
      if (ec) {
        try {
          ec.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'dataZoomSelect',
            dataZoomSelectActive: nextState,
          });
        } catch (_) { }
      }
    });
  }, [isZoomActive]);

  const tooltipTitle = isZoomActive ? 'Exit Box Zoom' : 'Click and drag on a panel to select an area to zoom';

  return (
    <CustomToolTip title={tooltipTitle}>
      <button
        id="telemetry-global-zoom-btn"
        className={`td-toolbar-btn td-toolbar-icon-btn ${isZoomActive ? 'td-toolbar-btn--active' : ''} ${className}`}
        onClick={handleToggleGlobalZoom}
        aria-label={tooltipTitle}
        style={style}
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
          <line x1="11" y1="8" x2="11" y2="14" />
          <line x1="8" y1="11" x2="14" y2="11" />
        </svg>
      </button>
    </CustomToolTip>
  );
};

export default TelemetryGlobalZoomButton;


